<script setup>
import FilterComponent from '@/@core/components/custom/FilterComponent.vue'
import AnalyticsTicketTracker from '@/@core/components/service-desk/AnalyticsTicketTracker.vue'
import CustomerCommunicationDrawer from '@/views/service-desk/customer-communication/Drawer.vue'
import CustomerCommunicationLogDrawer from '@/views/service-desk/customer-communication/LogDrawer.vue'
import TicketDrawer from '@/views/service-desk/drawer/TicketDrawer.vue'
import TicketFormDrawer from '@/views/service-desk/drawer/TicketFormDrawer.vue'
import TicketTable from '@/views/service-desk/ticket-management/TicketTable.vue'

definePage({
  meta: {
    name: 'ticket-management',
    subject: 'service_desk.menu',
    action: 'ticket_management',
  },  
})

const route = useRoute()

const ticketFilters = ref()

const { 
  data: filterOptions,
} = await useApi(createUrl('/service-desk/tickets/filters', {
  query: {
    type: 'service-desk',
  },
}))

const isTicketDrawerVisible = ref(false)
const ticketDrawerId = ref(null)
const refTicketTable = ref()
const communicationDrawerData = ref()

const showTicket = feedbackData => {
  ticketDrawerId.value = feedbackData?.id
  isTicketDrawerVisible.value = true
}

// check if ticket id is present in the route
if (route.query.ticket) {
  ticketDrawerId.value = route.query.ticket
  isTicketDrawerVisible.value = true
}

const isCommunicationDrawerVisible = ref(false)

const showCommunicationDrawer= (feedbackData, type, communicationFor='') => {
  communicationDrawerData.value = feedbackData
  communicationDrawerData.value.communicationFor = communicationFor
  isCommunicationDrawerVisible.value = true
}

const isCommunicationLogDrawerVisible = ref(false)

const showCommunicationLogDrawer = (feedbackData, type) => {
  communicationDrawerData.value = feedbackData
  isCommunicationLogDrawerVisible.value = true
}

const refTicketTracker =ref(null)

const refreshTicketData = async (closeDrawer = true) => {
  if (closeDrawer) isTicketDrawerVisible.value = false
  refTicketTable.value?.fetchTickets()
  refTicketTracker.value?.fetchStatusGraph()
}

const isCreateTicketDrawerVisible = ref(false)

const onUpdateTableFilter = data => {
  ticketFilters.value = {
    ...ticketFilters.value,
    ...data,
  }
}
</script>

<template>
  <section>
    <VRow class="match-height mb-4">
      <VCol
        cols="12"
        md="6"
        lg="6"
      >
        <FilterComponent
          v-model:filters="ticketFilters"
          :filters-options="filterOptions"
          :style="{ cardVariant: 'flat', cardClass: 'border' }"
        />
      </VCol>
      <VCol
        cols="12"
        md="6"
        lg="6"
      >
        <AnalyticsTicketTracker
          ref="refTicketTracker"
          :ticket-filters="ticketFilters"
          :style="{ cardVariant: 'flat', cardClass: 'border' }"
          page="ticket-management"
        />
      </VCol>
    </VRow>
    
    <TicketTable
      ref="refTicketTable"
      :ticket-filters="ticketFilters"
      page="ticket-management"
      @show-ticket="showTicket"
      @show-communication-drawer="showCommunicationDrawer"
      @show-communication-log-drawer="showCommunicationLogDrawer"
      @show-ticket-create-drawer="() => {
        isCreateTicketDrawerVisible = true
      }"
      @update:filter="onUpdateTableFilter"
    />

    <CustomerCommunicationDrawer
      v-model:isDrawerOpen="isCommunicationDrawerVisible"
      :customer="communicationDrawerData?.customer"
      notification-action="ticket_customer_communication"
    />

    <CustomerCommunicationLogDrawer
      v-model:isDrawerOpen="isCommunicationLogDrawerVisible"
      :customer="communicationDrawerData?.customer"
      notification-action="ticket_customer_communication"
    />
    
    <TicketDrawer
      v-model:isDrawerOpen="isTicketDrawerVisible"
      :ticket-id="ticketDrawerId"
      @refresh-ticket-data="refreshTicketData"
      @show-communication-drawer="showCommunicationDrawer"
    />

    <TicketFormDrawer
      v-model:isDrawerOpen="isCreateTicketDrawerVisible"
      :form-data="null"
      @refetch-listing="refreshTicketData(false)"
    />
  </section>
</template>
